export enum OrdersAppRoutesEnum {
  ORDERS_APP_PLACEHOLDER = 'ordersapp-placeholder',
  APP_REQUEST_DETAIL = 'ordersapp-request-detail',
}
